<script>
import axios from 'axios';
import * as yup from 'yup';
import { toTypedSchema } from '@vee-validate/yup';
import { Form, Field, ErrorMessage } from 'vee-validate';

export default {
  components: { Form, Field, ErrorMessage },
  data() {
    return {
      isSubmitted : false,
      isSubmitting: false,
      schema: toTypedSchema(yup.object({
        name: yup.string().required('Your name is required'),
        email: yup.string().email('Invalid email address').required('Email is required'),
        phone: yup.string().matches(/^[\d\[\]\s]{4,}$/, 'Enter a valid phone number').required('Phone is required'),
        message: yup.string().min(10, 'Message must be at least 10 characters long').required('Message is required'),
      })),
    };
  },
  methods: {
    async submitForm(values, {resetForm}) {
      this.isSubmitting = true;
      try {
        const response = await axios.post('/contact', values);
        resetForm();
        this.isSubmitted = true;
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<template>
  <div class="contact-us-form-section__form-area">
    <Form @submit="submitForm" :validation-schema="schema" ref="form">
      <div class="text-center" v-if="isSubmitted">
        <h3>Thank you!</h3>
          <p>Your message has been sent successfully</p>
      </div>

      <div class="row gy-1" v-if="!isSubmitted">
        <div class="col-12 form-group">
          <label class="form-label">Your Name *</label>
          <Field name="name" type="text" class="form-control" placeholder="Enter your name" />
          <ErrorMessage name="name" class="invalid-feedback" />
        </div>
        <div class="col-6 form-group">
          <label class="form-label">Email *</label>
          <Field name="email" type="email" class="form-control" placeholder="john.smith@email.com"  />
          <ErrorMessage name="email" class="invalid-feedback" />
        </div>
        <div class="col-6 form-group">
          <label class="form-label">Phone *</label>
          <Field name="phone" type="text" class="form-control" placeholder="04XX XXX XXX"  />
          <ErrorMessage name="phone" class="invalid-feedback" />
        </div>
        <div class="col-12 form-group">
          <label class="form-label">Message *</label>
          <Field name="message" as="textarea" class="form-control" rows="4" />
          <ErrorMessage name="message" class="invalid-feedback" />
        </div>
        <div class="col-12 form-group">
          <button type="submit" class="btn btn-lg btn-block btn-rounded" :disabled="isSubmitting">
            {{ isSubmitting ? 'Sending...' : 'Send' }}
          </button>
        </div>
      </div>
    </Form>
  </div>
</template>
